function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var Menu = require('./menu');
var Manager = require('./manager');
var UserStoreSidebar = require('./user-store-sidebar');
var NftPickerOverlay = require('./overlays/nft-picker');
var PrepareStoreOverlay = require('./overlays/prepare-store');
var ListingDetailOverlay = require('./overlays/listing-detail');
var ListingInspectOverlay = require('./overlays/listing-inspect');
var RentalListingOverlay = require('./overlays/rental-listing');
var PurchaseOverlay = require('./overlays/purchase');
var Web3PaymentOverlay = require('./overlays/web3-payment');
var SettingsOverlay = require('./overlays/settings');
var PurchaseLifecycle = require('./purchase-lifecycle');
var ListingLifecycle = require('./listing-lifecycle');
var _require = require('../categories'),
  normalizeListingMode = _require.normalizeListingMode,
  categoryViewKey = _require.categoryViewKey;
var _require2 = require('./overlays/listing-field-edit'),
  requestStoreWeb3Tickers = _require2.requestStoreWeb3Tickers;
var Main = /*#__PURE__*/function () {
  function Main(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-container';
    _classCallCheck(this, Main);
    this.app = app;
    this.mod = mod;
    this.container = container;
    /** @type {'marketplace' | 'user-store' | 'admin'} */
    this.composition = 'marketplace';
    if (!this.mod.purchase_lifecycle) {
      this.mod.purchase_lifecycle = new PurchaseLifecycle(app, mod);
    }
    if (!this.mod.listing_lifecycle) {
      this.mod.listing_lifecycle = new ListingLifecycle(app, mod);
    }
    this.menu = new Menu(app, mod, '', {
      onNavigate: function onNavigate(view, opts) {
        return _this.onNavigate(view, opts);
      },
      onSell: function onSell() {
        return _this.openSell();
      },
      onSettings: function onSettings() {
        return _this.openSettings();
      },
      onStoreModeChange: function onStoreModeChange(mode) {
        return _this.onStoreModeChange(mode);
      }
    });
    this.user_store_sidebar = new UserStoreSidebar(app, mod, '');
    this.manager = new Manager(app, mod, '', {
      onSell: function onSell() {
        return _this.openSell();
      },
      onStoreModeChange: function onStoreModeChange(mode) {
        return _this.onStoreModeChange(mode);
      }
    });
    this.nft_picker = null;
    this.prepare_store = null;
    this.listing_detail = null;
    this.listing_inspect = null;
    this.purchase_overlay = null;
    this.settings_overlay = null;

    // Compatibility aliases for existing callers (store.respondTo, teaser, detail buy).
    this.product_overlay = null;
    this.listing_overlay = null;
    this.purchase_flow = null;
    this.app.connection.on('store-render-listings', function () {
      _this.manager.reloadBrowsePage();
    });
    if (this.app.BROWSER && typeof window !== 'undefined') {
      window.addEventListener('popstate', function () {
        return _this.onPathChange();
      });
    }
  }
  return _createClass(Main, [{
    key: "userStoreContextSelector",
    value: function userStoreContextSelector() {
      return "".concat(this.container, " .store > .user-store-context");
    }
  }, {
    key: "storeRoot",
    value: function storeRoot() {
      return document.querySelector("".concat(this.container, " .store"));
    }

    /**
     * Page composition modes share Main/Manager, but not left-rail semantics:
     * - marketplace / admin → `.menu` (categories or dashboard)
     * - user-store → `.user-store-context` (SaitoProfile + Store nav); listings stay in `.main-column`
     */
  }, {
    key: "setComposition",
    value: function setComposition() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'marketplace';
      var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var next = mode === 'user-store' ? 'user-store' : mode === 'admin' ? 'admin' : 'marketplace';
      this.composition = next;
      var store = this.storeRoot();
      if (store) {
        store.classList.toggle('user-store', next === 'user-store');
      }
      if (next === 'user-store') {
        this.user_store_sidebar.render(this.userStoreContextSelector(), publicKey);
        return;
      }
      if (next === 'admin') {
        this.menu.setMode('dashboard', {
          dashboardView: this.menu.dashboardView || 'store-admin'
        });
        return;
      }
      this.menu.setMode('browse');
    }
  }, {
    key: "onPathChange",
    value: function onPathChange() {
      var _this$mod$returnStore, _this$mod;
      var route = ((_this$mod$returnStore = (_this$mod = this.mod).returnStoreRouteFromPath) === null || _this$mod$returnStore === void 0 ? void 0 : _this$mod$returnStore.call(_this$mod)) || {
        publicKey: '',
        admin: false,
        moderate: false,
        category: ''
      };
      if (route.moderate) {
        void this.openModerate({
          updateUrl: false
        });
        return;
      }
      if (route.publicKey) {
        this.openStorefront(route.publicKey, {
          updateUrl: false,
          admin: !!route.admin,
          category: route.category
        });
        return;
      }
      this.setComposition('marketplace');
      this.menu.setActive(route.category ? categoryViewKey(route.category) : 'all');
      this.manager.show('browse');
      this.loadBrowsePage({
        category: route.category || '',
        page: 1
      });
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.nft_picker = new NftPickerOverlay(this.app, this.mod);
              this.prepare_store = new PrepareStoreOverlay(this.app, this.mod);
              this.listing_detail = new ListingDetailOverlay(this.app, this.mod);
              this.listing_inspect = new ListingInspectOverlay(this.app, this.mod);
              this.rental_listing = new RentalListingOverlay(this.app, this.mod);
              this.purchase_overlay = new PurchaseOverlay(this.app, this.mod);
              this.web3_payment = new Web3PaymentOverlay(this.app, this.mod);
              this.settings_overlay = new SettingsOverlay(this.app, this.mod);
              this.prepare_store.onContinue = function (defaults) {
                _this2.nft_picker.render(defaults || {});
              };
              this.prepare_store.onCreateNft = function (defaults) {
                _this2.nft_picker.defaults = defaults || {};
                _this2.nft_picker.openCreateNft();
              };
              this.nft_picker.onSelect = function (nft, defaults) {
                if (normalizeListingMode(defaults === null || defaults === void 0 ? void 0 : defaults.listing_mode) === 'rent') {
                  _this2.rental_listing.render({
                    source_nft: nft,
                    defaults: defaults
                  });
                  return;
                }
                _this2.listing_detail.render({
                  mode: 'edit',
                  nft: nft,
                  defaults: defaults
                });
              };
              this.listing_detail.onBack = function (defaults) {
                _this2.nft_picker.render(defaults || {});
              };
              this.rental_listing.onBack = function (defaults) {
                _this2.nft_picker.render(_objectSpread(_objectSpread({}, defaults || {}), {}, {
                  listing_mode: 'rent'
                }));
              };
              this.product_overlay = this.listing_detail;
              this.purchase_flow = this.purchase_overlay;
              this.listing_overlay = {
                render: function render() {
                  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  return _this2.openSell(defaults);
                }
              };
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      var root = document.querySelector(this.container);
      if (root) {
        root.classList.add('store-container');
      }
      this.app.browser.replaceElementContentBySelector(MainTemplate(), this.container);
      this.menu.render("".concat(this.container, " .store > .menu"));
      this.manager.render("".concat(this.container, " .store > .main-column > .manager"));
    }
  }, {
    key: "onNavigate",
    value: function onNavigate() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (view === 'my-store' || view === 'store-admin') {
        this.openStorefront(this.mod.publicKey, {
          admin: true
        });
        return;
      }
      if (view === 'view-store') {
        this.openStorefront(this.mod.publicKey, {
          admin: false
        });
        return;
      }
      if (view === 'active') {
        this.openStorefront(this.mod.publicKey, {
          updateUrl: true,
          celebrate: false,
          admin: true,
          dashboardView: 'active'
        });
        return;
      }
      if (view === 'sold') {
        this.openSales();
        return;
      }
      if (view === 'withdrawals') {
        this.openWithdrawals();
        return;
      }
      if (view === 'moderation') {
        void this.openModerate();
        return;
      }
      if (view === 'all') {
        this.setComposition('marketplace');
        this.menu.setActive('all');
        this.manager.show('browse');
        this.setBrowseUrl();
        this.loadBrowsePage({
          category: '',
          page: 1,
          scroll: true
        });
        return;
      }

      // Category browse (data-category from menu items).
      if (Object.prototype.hasOwnProperty.call(opts, 'category')) {
        this.setComposition('marketplace');
        this.manager.show('browse');
        this.setBrowseUrl();
        this.loadBrowsePage({
          category: String(opts.category || ''),
          page: 1,
          scroll: true
        });
      }
    }
  }, {
    key: "loadBrowsePage",
    value: function loadBrowsePage() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$category = _ref.category,
        category = _ref$category === void 0 ? '' : _ref$category,
        _ref$page = _ref.page,
        page = _ref$page === void 0 ? 1 : _ref$page,
        _ref$scroll = _ref.scroll,
        scroll = _ref$scroll === void 0 ? false : _ref$scroll;
      return this.manager.loadBrowsePage({
        category: category,
        page: page,
        scroll: scroll
      });
    }

    /**
     * Open a creator storefront or seller admin page.
     * Public /store/<pk> always shows the public storefront (even for the owner).
     * Admin /store/<pk>/admin requires the logged-in wallet to match <pk>.
     */
  }, {
    key: "openStorefront",
    value: function () {
      var _openStorefront = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var publicKey,
          _ref2,
          _ref2$updateUrl,
          updateUrl,
          _ref2$celebrate,
          celebrate,
          _ref2$dashboardView,
          dashboardView,
          _ref2$admin,
          admin,
          _ref2$category,
          category,
          key,
          isOwn,
          view,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              publicKey = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              _ref2 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref2$updateUrl = _ref2.updateUrl, updateUrl = _ref2$updateUrl === void 0 ? true : _ref2$updateUrl, _ref2$celebrate = _ref2.celebrate, celebrate = _ref2$celebrate === void 0 ? false : _ref2$celebrate, _ref2$dashboardView = _ref2.dashboardView, dashboardView = _ref2$dashboardView === void 0 ? 'store-admin' : _ref2$dashboardView, _ref2$admin = _ref2.admin, admin = _ref2$admin === void 0 ? false : _ref2$admin, _ref2$category = _ref2.category, category = _ref2$category === void 0 ? '' : _ref2$category;
              key = String(publicKey || this.mod.publicKey || '').trim();
              if (key) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              isOwn = !!this.mod.publicKey && key === this.mod.publicKey;
              if (!admin) {
                _context2.n = 5;
                break;
              }
              if (!isOwn) {
                _context2.n = 3;
                break;
              }
              view = celebrate ? 'store-admin' : ['store-admin', 'active'].includes(dashboardView) ? dashboardView : 'store-admin';
              this.menu.dashboardView = view;
              this.setComposition('admin');
              if (celebrate) {
                this.manager.storefront.armSuccessBanner();
              }
              _context2.n = 2;
              return this.manager.showStorefront(key, {
                viewMode: 'admin',
                adminSection: view === 'active' ? 'active' : 'home',
                category: category
              });
            case 2:
              _context2.n = 4;
              break;
            case 3:
              this.setComposition('marketplace');
              _context2.n = 4;
              return this.manager.showStorefront(key, {
                viewMode: 'admin-denied',
                category: category
              });
            case 4:
              if (updateUrl) {
                this.setAdminUrl(key);
              }
              return _context2.a(2);
            case 5:
              this.setComposition('user-store', key);
              _context2.n = 6;
              return this.manager.showStorefront(key, {
                viewMode: 'public',
                category: category
              });
            case 6:
              if (updateUrl) {
                this.setStorefrontUrl(key);
              }
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function openStorefront() {
        return _openStorefront.apply(this, arguments);
      }
      return openStorefront;
    }()
  }, {
    key: "openSales",
    value: function openSales() {
      this.menu.dashboardView = 'sold';
      this.setComposition('admin');
      this.manager.showSales();
      if (this.mod.publicKey) {
        this.setAdminUrl(this.mod.publicKey);
      }
    }
  }, {
    key: "openWithdrawals",
    value: function openWithdrawals() {
      this.menu.dashboardView = 'withdrawals';
      this.setComposition('admin');
      this.manager.showWithdrawals();
      if (this.mod.publicKey) {
        this.setAdminUrl(this.mod.publicKey);
      }
    }
  }, {
    key: "onStoreModeChange",
    value: function onStoreModeChange() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'active';
      if (mode === 'sold') {
        this.openSales();
        return;
      }
      this.openStorefront(this.mod.publicKey, {
        updateUrl: true,
        celebrate: false,
        admin: true,
        dashboardView: 'active'
      });
    }
  }, {
    key: "setBrowseUrl",
    value: function setBrowseUrl() {
      var _this$mod$returnSlug, _this$mod2;
      if (!this.app.BROWSER || typeof history === 'undefined') {
        return;
      }
      var path = '/' + (((_this$mod$returnSlug = (_this$mod2 = this.mod).returnSlug) === null || _this$mod$returnSlug === void 0 ? void 0 : _this$mod$returnSlug.call(_this$mod2)) || 'store');
      if (window.location.pathname !== path) {
        history.pushState({
          store: 'browse'
        }, '', path);
      }
    }
  }, {
    key: "setModerateUrl",
    value: function setModerateUrl() {
      var _this$mod$returnSlug2, _this$mod3;
      if (!this.app.BROWSER || typeof history === 'undefined') {
        return;
      }
      var path = '/' + (((_this$mod$returnSlug2 = (_this$mod3 = this.mod).returnSlug) === null || _this$mod$returnSlug2 === void 0 ? void 0 : _this$mod$returnSlug2.call(_this$mod3)) || 'store') + '/moderate';
      if (window.location.pathname !== path) {
        history.pushState({
          store: 'moderate'
        }, '', path);
      }
    }
  }, {
    key: "openModerate",
    value: function openModerate() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$updateUrl = _ref3.updateUrl,
        updateUrl = _ref3$updateUrl === void 0 ? true : _ref3$updateUrl;
      this.setComposition('marketplace');
      this.menu.setActive('moderation');
      void this.manager.showModerate();
      if (updateUrl) {
        this.setModerateUrl();
      }
    }
  }, {
    key: "setStorefrontUrl",
    value: function setStorefrontUrl() {
      var _this$mod$returnStore2, _this$mod4;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.app.BROWSER || typeof history === 'undefined' || !publicKey) {
        return;
      }
      var path = (_this$mod$returnStore2 = (_this$mod4 = this.mod).returnStorefrontPath) === null || _this$mod$returnStore2 === void 0 ? void 0 : _this$mod$returnStore2.call(_this$mod4, publicKey);
      if (path && window.location.pathname !== path) {
        history.pushState({
          store: 'storefront',
          publicKey: publicKey
        }, '', path);
      }
    }
  }, {
    key: "setAdminUrl",
    value: function setAdminUrl() {
      var _this$mod$returnAdmin, _this$mod5;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.app.BROWSER || typeof history === 'undefined' || !publicKey) {
        return;
      }
      var path = (_this$mod$returnAdmin = (_this$mod5 = this.mod).returnAdminPath) === null || _this$mod$returnAdmin === void 0 ? void 0 : _this$mod$returnAdmin.call(_this$mod5, publicKey);
      if (path && window.location.pathname !== path) {
        history.pushState({
          store: 'admin',
          publicKey: publicKey
        }, '', path);
      }
    }

    /**
     * True when this wallet already has a storefront (menu cache, Profile URL, or listings).
     */
  }, {
    key: "hasOwnStore",
    value: function hasOwnStore() {
      var _this$menu, _this$mod$returnProfi, _this$mod6, _this$manager, _storefront$activeSum;
      if ((_this$menu = this.menu) !== null && _this$menu !== void 0 && _this$menu.has_store) {
        return true;
      }
      if ((_this$mod$returnProfi = (_this$mod6 = this.mod).returnProfileStoreUrl) !== null && _this$mod$returnProfi !== void 0 && _this$mod$returnProfi.call(_this$mod6)) {
        return true;
      }
      var storefront = (_this$manager = this.manager) === null || _this$manager === void 0 ? void 0 : _this$manager.storefront;
      return !!(storefront !== null && storefront !== void 0 && storefront.inventoryLoaded && storefront.publicKey === this.mod.publicKey && ((_storefront$activeSum = storefront.activeSummaries) === null || _storefront$activeSum === void 0 ? void 0 : _storefront$activeSum.length) > 0);
    }
  }, {
    key: "openSell",
    value: function openSell() {
      var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      requestStoreWeb3Tickers(this.app, {
        force: true
      });
      var next = _objectSpread(_objectSpread({}, defaults), {}, {
        listing_mode: normalizeListingMode(defaults.listing_mode)
      });
      if (next !== null && next !== void 0 && next.nft) {
        if (next.listing_mode === 'rent') {
          this.rental_listing.render({
            source_nft: next.nft,
            defaults: next
          });
          return;
        }
        this.listing_detail.render({
          mode: 'edit',
          nft: next.nft,
          defaults: next
        });
        return;
      }
      if (this.prepare_store && !this.hasOwnStore()) {
        this.prepare_store.render(next);
        return;
      }
      this.nft_picker.render(next);
    }
  }, {
    key: "openSettings",
    value: function openSettings() {
      var _this$settings_overla;
      (_this$settings_overla = this.settings_overlay) === null || _this$settings_overla === void 0 || _this$settings_overla.render();
    }
  }]);
}();
module.exports = Main;